import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom'
// Icons
import 'flag-icon-css/css/flag-icon.min.css';
import 'font-awesome/css/font-awesome.min.css'
import 'simple-line-icons/css/simple-line-icons.css'

// 
import 'ag-grid/dist/styles/ag-grid.css'
import 'ag-grid/dist/styles/ag-theme-balham.css'
import 'react-datepicker/dist/react-datepicker.css'

// Main styles
import 'semantic-ui-css/semantic.min.css';
import 'assets/css/style.css';
import 'assets/css/pace.css';
import 'App.css';

import 'bootstrap/dist/js/bootstrap.min.js';
import '@coreui/coreui/dist/js/coreui.min.js';

import 'toastr/build/toastr.css'

import { session } from 'services/session'
import ApiHelper from "services/api-helper"
import Login from 'components/login'
import Layout from 'components/layout';

const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route {...rest} render={(props) =>
    session
      ? <Component {...props} />
      : <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
  } />
)

class App extends Component {
  componentWillMount() {
    ApiHelper.GetJson('/api/isLogin').then(res => {
      // nếu không có session thì chuyển về trang login
      // nếu vào trang login mà có session thì chuyển về trang chủ
      if (!res && window.location.pathname !== "/login") window.location.href = "/login";
      else if (res && window.location.pathname === "/login") window.location.href = "/";
    }, error => {
      console.log(error);
    })
  }

  render() {
    return (
      <Router>
        <Switch>
          <Route exact path="/login" component={Login} />
          <PrivateRoute path="*" component={Layout} />
        </Switch>
      </Router>
    );
  }
}

export default App;


// WEBPACK FOOTER //
// ./src/App.jsx